module.exports = __webpack_public_path__ + "img/index1.86fbe1e1.png";